import { render, staticRenderFns } from "./LogisticsCheck.vue?vue&type=template&id=04a28b34&"
import script from "./LogisticsCheck.vue?vue&type=script&lang=js&"
export * from "./LogisticsCheck.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports